<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <img src="@/assets/icons/Error.svg" alt="" class="icon" />
      <p class="text">{{ message }}</p>
      <StandardButton :buttonLabel="'Aceptar'" @click="closeModalError" />
    </div>
  </div>
</template>

<script lang="ts">
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalError",
  components: {
    StandardButton,
  },
  props: {
    message: {
      type: String,
      default: "",
    },
  },

  setup(props, context) {
    function closeModalError() {
      context.emit("update:error", false);
    }

    return {
      closeModalError,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/modals/modalSuccessErrorStyle";
</style>
